// extracted by mini-css-extract-plugin
export default {"clearButtonCustom":"clearButtonCustom__dq2r+"};